import AbsSection from '../common/AbsSection';
import MoviePlayer from '../common/MoviePlayer';
import { TweenMax } from 'gsap/all';

import LayerTribute from './LayerTribute';
import LayerKeynote from './LayerKeynote';

class SecBanquet extends AbsSection{

    constructor(_store={}, _el=''){
        super('banquet', _store, _el);
    }
    
    setting(){
        this.videoList = {
            mobile: {
                intro: {
                    url: this.moviepath + '/new/sujungapear_MO_high.mp4',
                    width: 1920*0.7, height: 1080*0.7
                },
                loop: {
                    url: this.moviepath + '/party/2_rooping_MO_low2.mp4',
                    width: 1920*0.7, height: 1080*0.7
                },
                loop2: {
                    url: this.moviepath + '/new/3_afterkey_MO_low.mp4',
                    width: 1920*0.7, height: 1080*0.7
                },
                out: {
                    url: this.moviepath + '/party/4_golobby_MO_low2.mp4',
                    width: 1920*0.7, height: 1080*0.7
                }
            }, 
            tablet: {
                intro: {
                    url: this.moviepath + '/new/sujungapear_MO_high.mp4',
                    width: 1920, height: 1080
                },
                loop: {
                    url: this.moviepath + '/party/2_rooping_MO_low2.mp4',
                    width: 1920, height: 1080
                },
                loop2: {
                    url: this.moviepath + '/new/3_afterkey_MO_low.mp4',
                    width: 1920, height: 1080
                },
                out: {
                    url: this.moviepath + '/party/4_golobby_MO_low2.mp4',
                    width: 1920, height: 1080
                }
            }, 
            pc: {
                intro: {
                    url: this.moviepath + '/new/1_partyenter_PC_low.mp4',
                    width: 2276, height: 1280
                },
                loop: {
                    url: this.moviepath + '/party/2_rooping_PC_low2.mp4',
                    width: 2276, height: 1280
                },
                loop2: {
                    url: this.moviepath + '/new/3_afterkey_PC_low.mp4',
                    width: 2276, height: 1280
                },
                out: {
                    url: this.moviepath + '/party/4_golobby_PC_low2.mp4',
                    width: 2276, height: 1280
                }
            }
        }[ this.store.getState().config.device ];

        this.vidintro = new MoviePlayer( {
            url: this.videoList.intro.url,
            parentNode: $( this.el + ' .vid .draggable'),
            movieW: this.videoList.intro.width, movieH: this.videoList.intro.height,
            selector: 'secBanquetIntro', videoControl: 'preload="auto" playsinline muted="muted"',
            isBgType: false,
            stateCallback: (state)=> {
                if (state==='ended') {

                    this.vidioReset(this.vidintro, 1, true).pause();
                    setTimeout(() => this.vidioReset(this.vidintro, 1, false) , 1000);

                    if (this.store.getState().secCookies.banquetIntro && this.store.getState().secCookies.banquetKeynote) {
                        this.vidioReset(this.vidLoop2, 2, true).play(0);
                        this.showLastBtns();
                    } else {
                        this.vidioReset(this.vidLoop1, 2, true).play(0);
                    }
                }
            }
        });

        this.vidLoop1 = new MoviePlayer( {
            url: this.videoList.loop.url,
            parentNode: $( this.el + ' .vid .draggable'),
            movieW: this.videoList.loop.width, movieH: this.videoList.loop.height,
            selector: 'secBanquetLoop', videoControl: 'preload="auto" playsinline muted="muted" loop',
            isBgType: false,
            stateCallback: (state)=> {}
        });

        this.vidLoop2 = new MoviePlayer( {
            url: this.videoList.loop2.url,
            parentNode: $( this.el + ' .vid .draggable'),
            movieW: this.videoList.loop2.width, movieH: this.videoList.loop2.height,
            selector: 'secBanquetLoop2', videoControl: 'preload="auto" playsinline muted="muted" loop',
            isBgType: false,
            stateCallback: (state)=> {}
        });

        this.vidOut = new MoviePlayer( {
            url: this.videoList.out.url,
            parentNode: $( this.el + ' .vid .draggable'),
            movieW: this.videoList.out.width, movieH: this.videoList.out.height,
            selector: 'secBanquetOut', videoControl: 'preload="auto" playsinline muted="muted"',
            isBgType: false,
            stateCallback: (state)=> {
                if (state==='ended') {
                    this.vidOut.node.toggle(false);
                    this.vidioReset(this.vidLoop1).pause(0);
                    this.transitionEnd();
                }
            }
        });

        let cssobj = { width: this.videoList.loop.width };
        if (this.$win.width()>this.videoList.loop.width) {
            cssobj['margin-left'] = -this.videoList.loop.width/2;
            cssobj['left'] = '50%';
        }
        this.vidintro.node.css(cssobj);
        this.vidLoop1.node.css(cssobj);
        this.vidLoop2.node.css(cssobj);
        this.vidOut.node.css(cssobj);

        this.drag = Draggable.create(this.el + " .drag-wrap", { type: "scroll", edgeResistance: 1, throwProps: true })[0];

        this.bi = $(this.el + ' .title');
        this.keynoteBtn1 = $(this.el + ' .section-contents .btn-keynote');
        this.keynoteBtn2 = $(this.el + ' .section-contents .btn-keynote_replay');
        this.tributeBtn = $(this.el + ' .section-contents .btn-tribute');
        this.livingroomBtn = $(this.el + ' .draggable .btn-next');
        
        this.layerTribute = new LayerTribute(this.store);
        this.layerKeynote = new LayerKeynote(this.store);

        this.reset();
    }

    addEvents() {
        this.livingroomBtn.on('click', e => {
            this.store.dispatch( this.actions.setNowpage($(e.currentTarget).data('name')) );
        });

        $('#container').on('layer.open', (e, layerSel)=>{
            let state = this.store.getState();
            if( layerSel==='#layer-tribute' ){
                this.layerTribute.open();
            }
            if( layerSel==='#layer-keynote' ){
                this.layerKeynote.open();
            }
        });
        
        $('#container').on('layer.close', (e, layerSel)=>{
            let state = this.store.getState();
            if( layerSel==='#layer-tribute' ){
                if (!state.secCookiesIsFull) {
                    this.vidioReset(this.vidintro, 2, true).play(0);
                    if ( !state.secCookies.banquetKeynote ) {
                        TweenMax.to(this.keynoteBtn1, 0.5, {autoAlpha:1, y: 0, delay: 1});
                    }
                }
                this.layerTribute.close();
            }

            if( layerSel==='#layer-keynote' ){
                if (!state.secCookiesIsFull) {
                    this.vidioReset(this.vidLoop1, 1).pause();
                    this.vidioReset(this.vidLoop2, 2, true).play(0);
                    this.showLastBtns();
                }
                this.layerKeynote.close();
            }
        });
    }

    setAniObj () {
        super.setAniObj();
        TweenMax.set(this.bi, {autoAlpha:0, scale: 1.3});
        TweenMax.set(this.tributeBtn, {autoAlpha:0, y: 70});
        TweenMax.set(this.keynoteBtn1, {autoAlpha:0, y: 70});
        TweenMax.set(this.keynoteBtn2, {autoAlpha:0, y: 70});
        TweenMax.set(this.livingroomBtn , {autoAlpha:0, scale: 0.7});
        TweenMax.set(this.vidLoop1.node, {autoAlpha:1, scale: 1});
        TweenMax.set(this.vidLoop2.node, {autoAlpha:1, scale: 1});
    }

    showLastBtns(){
        TweenMax.to(this.tributeBtn, 0.5, {autoAlpha:1, y: 0});
        TweenMax.set(this.keynoteBtn1, {autoAlpha:0, y: 70});
        TweenMax.to(this.keynoteBtn2, 0.5, {autoAlpha:1, y: 0});
        TweenMax.to(this.livingroomBtn, 0.5, {autoAlpha:1, scale: 1});
    }

    titleAni () {
        this.bi.show();
        TweenMax.to(this.bi, 3.5, {autoAlpha:1, scale: 1});

        TweenMax.fromTo(this.el + ' .noti-drag', 0.8, 
            { autoAlpha: 1, display: 'block' }, 
            { autoAlpha: 0, display: 'none', delay: 1.5 }
        );
    }

    start(){
        super.start();

        if (this.store.getState().secCookies.banquetIntro && this.store.getState().secCookies.banquetKeynote) {
            this.vidioReset(this.vidintro, 2, true).play(0);
        } else {
            this.tributeBtn.trigger('click');
        }
    }

    end(){
        super.end();
        this.vidioReset(this.vidintro, 0, false).pause();

        if (this.nextSecName==='livingroom') {
            if(this.vidLoop1.node.is(':visible')){
                this.vidioReset(this.vidLoop1, 1, true).pause();
                setTimeout(() => this.vidioReset(this.vidLoop1, 0, false) , 1000);

                this.vidioReset(this.vidLoop2, 0, false).pause();
            } else {
                this.vidioReset(this.vidLoop1, 0, false).pause();

                this.vidioReset(this.vidLoop2, 1, true).pause();
                setTimeout(() => this.vidioReset(this.vidLoop2, 0, false) , 1000);
            }
            this.vidioReset(this.vidOut, 2, true).play(0);
        } else {
            this.vidioReset(this.vidOut, 0, false).pause();
            
            if(this.vidLoop1.node.is(':visible')){
                this.vidioReset(this.vidLoop2, 0, false).pause();
                this.vidioReset(this.vidLoop1, 2, true).play(0);
                TweenMax.to(this.vidLoop1.node, 1.3, {autoAlpha:0, scale: 1.3, ease: Expo.easeIn, onComplete: ()=> {
                    this.transitionEnd();
                }});
            } else {
                this.vidioReset(this.vidLoop1, 0, false).pause();
                this.vidioReset(this.vidLoop2, 2, true).play(0);
                TweenMax.to(this.vidLoop2.node, 1.3, {autoAlpha:0, scale: 1.3, ease: Expo.easeIn, onComplete: ()=> {
                    this.transitionEnd();
                }});
            }
        }
        TweenMax.to(this.bi, 1.2, {autoAlpha:0, scale: 1.3, ease: Quint.easeIn});
        TweenMax.to(this.tributeBtn, 1.2, {autoAlpha:0, y: 70, ease: Quint.easeIn});
        TweenMax.to(this.keynoteBtn1, 1.2, {autoAlpha:0, y: 70, ease: Quint.easeIn});
        TweenMax.to(this.keynoteBtn2, 1.2, {autoAlpha:0, y: 70, ease: Quint.easeIn});
        TweenMax.to(this.livingroomBtn, 1.2, {autoAlpha:0, scale: 0.7, ease: Quint.easeIn});
    }

    reset(){
        super.reset();
        this.vidioReset(this.vidintro).pause();
        this.vidioReset(this.vidLoop1).pause();
        this.vidioReset(this.vidLoop2).pause();
        this.vidioReset(this.vidOut).pause();
    }

} // end of class
export default SecBanquet;